<button [class.primary]="activeLocalizations" (click)="open()">
	<mat-icon>language</mat-icon>
</button>
